import { render, staticRenderFns } from "./configManageAuditor.vue?vue&type=template&id=c2e0b12c&scoped=true"
import script from "./configManageAuditor.vue?vue&type=script&lang=js"
export * from "./configManageAuditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e0b12c",
  null
  
)

export default component.exports